import { Navigate } from 'react-router-dom';
import ChatAgentForm from '../../../components/agents/ChatAgentForm/ChatAgentForm';
import Loading from '../../../components/shared/Loading/Loading';
import Page from '../../../components/shared/Page/Page';
import useGetAgentById from '../../../hooks/useGetAgentById';
import { AgentType } from '../../../interfaces/Agent';
import { WorkflowType } from '../../../interfaces/App';

const EditChatAgent = () => {
  const { agent, knowledge, isLoading, shouldNavigate } = useGetAgentById(
    AgentType.CHAT
  );

  if (shouldNavigate) {
    return <Navigate to="/dashboard" />;
  }

  // `knowledge` stays undefined for an agent without a knowledge base (it's
  // optional), so it isn't part of the loading condition.
  if (isLoading || !agent) return <Loading />;

  return (
    <Page withBackground hideMainMenu>
      <ChatAgentForm
        chatAgent={agent}
        workflow={WorkflowType.EDIT}
        knowledge={knowledge}
      />
    </Page>
  );
};

export default EditChatAgent;
